var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "mb-6 mt-6" }, [
    _c("div", { staticClass: "flex flex-col sm:rounded-lg bg-white" }, [
      _c("div", { staticClass: "flex-grow overflow-auto overflow-x-visible" }, [
        _c(
          "table",
          {
            staticClass:
              "relative w-full text-sm font-normal text-left dark:text-gray-400",
          },
          [
            _vm._m(0),
            _c(
              "tbody",
              { staticClass: "divide-y" },
              _vm._l(_vm.suitableContractors, function (resource) {
                return _c(
                  "tr",
                  {
                    key: resource.id,
                    staticClass:
                      "bg-white text-black border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600",
                  },
                  [
                    _c("td", { staticClass: "px-4 py-4" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "text-storm-gray text-sm p-1.5 font-medium rounded-full block border border-gray-300 bg-white borderCard hover:text-primary-500 hover:border-primary-500",
                        },
                        [
                          resource.name
                            ? _c(
                                "div",
                                {
                                  staticClass: "flex flex-row items-center",
                                  attrs: {
                                    name: "imageAvatar",
                                    image: resource.avatar,
                                  },
                                },
                                [
                                  resource.avatar !== null
                                    ? _c("S3Image", {
                                        class: [
                                          _vm.defaultImageClasses,
                                          _vm.avatarStyleClasses,
                                        ],
                                        attrs: { s3FileKey: resource.avatar },
                                      })
                                    : _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-xs leading-none font-semibold mr-1",
                                          class: _vm.getAvatrClass,
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getInitials(resource.name)
                                            ) + " "
                                          ),
                                        ]
                                      ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-storm-gray text-sm font-medium",
                                    },
                                    [_vm._v(" " + _vm._s(resource.name) + " ")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _c("td", { staticClass: "px-4 py-4" }, [
                      _vm._v(_vm._s(_vm.contarctorJob(resource))),
                    ]),
                    _c("td", { staticClass: "px-4 py-4" }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-3" },
                        [
                          _c("UiButton", {
                            attrs: {
                              buttonText: "Assign",
                              variant: "black",
                              size: "lg2",
                              buttonClasses: "customHeight40",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleAssignClick(resource)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "18",
                                            height: "18",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                "clip-path":
                                                  "url(#clip0_2964_15353)",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M9.23077 1.23077C9.23077 0.55 8.68077 0 8 0C7.31923 0 6.76923 0.55 6.76923 1.23077V6.76923H1.23077C0.55 6.76923 0 7.31923 0 8C0 8.68077 0.55 9.23077 1.23077 9.23077H6.76923V14.7692C6.76923 15.45 7.31923 16 8 16C8.68077 16 9.23077 15.45 9.23077 14.7692V9.23077H14.7692C15.45 9.23077 16 8.68077 16 8C16 7.31923 15.45 6.76923 14.7692 6.76923H9.23077V1.23077Z",
                                                  fill: "white",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c("defs", [
                                            _c(
                                              "clipPath",
                                              {
                                                attrs: {
                                                  id: "clip0_2964_15353",
                                                },
                                              },
                                              [
                                                _c("rect", {
                                                  attrs: {
                                                    width: "18",
                                                    height: "18",
                                                    fill: "white",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "17",
                                            height: "16",
                                            viewBox: "0 0 17 16",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M9.73077 1.23077C9.73077 0.55 9.18077 0 8.5 0C7.81923 0 7.26923 0.55 7.26923 1.23077V6.76923H1.73077C1.05 6.76923 0.5 7.31923 0.5 8C0.5 8.68077 1.05 9.23077 1.73077 9.23077H7.26923V14.7692C7.26923 15.45 7.81923 16 8.5 16C9.18077 16 9.73077 15.45 9.73077 14.7692V9.23077H15.2692C15.95 9.23077 16.5 8.68077 16.5 8C16.5 7.31923 15.95 6.76923 15.2692 6.76923H9.73077V1.23077Z",
                                              fill: "black",
                                              "fill-opacity": "0.88",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("UiButton", {
                            attrs: {
                              buttonText: "Message",
                              variant: "outline-black",
                              buttonClasses: "py-2 pr-4 pl-4",
                              size: "lg2",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openMessage(resource)
                              },
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c("MessageIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c("MessageIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: _vm.$router.resolve(
                                  _vm.contractorPageRoute(resource)
                                ).href,
                                target: "_blank",
                                rel: "noopener noreferrer",
                              },
                            },
                            [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "flex flex-row items-center eyeButton",
                                },
                                [_c("TableViewIcon")],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._m(1, true),
                  ]
                )
              }),
              0
            ),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "thead",
      {
        staticClass: "text-m text-black headingTable sticky top-0 z-100 w-full",
      },
      [
        _c("tr", [
          _c(
            "th",
            {
              staticClass: "px-4 py-4 text-sm relative font-medium leading-6",
              staticStyle: { width: "40%" },
              attrs: { scope: "col" },
            },
            [
              _vm._v(" Resource "),
              _c("span", { staticClass: "right-border px-4 absolute right-4" }),
            ]
          ),
          _c(
            "th",
            {
              staticClass: "px-4 py-4 text-sm relative font-medium leading-6",
              staticStyle: { width: "40%" },
              attrs: { scope: "col" },
            },
            [
              _vm._v(" Job Title "),
              _c("span", { staticClass: "right-border px-4 absolute right-4" }),
            ]
          ),
          _c("th", {
            staticClass: "px-4 py-4 text-sm relative",
            staticStyle: { width: "20%" },
            attrs: { scope: "col" },
          }),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("td", [
      _c("div", { staticClass: "flex flex-row gap-1.5 items-center" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }